import React from 'react';

import { angularizeWithProviders } from '../../../../shared/providers';
import { DetailedRevenue } from '../../../containers/DetailedRevenue/DetailedRevenue';

type NgzDetailedRevenueTabProps = {
  entityId: number;
  entityRegistrationDate: string | null; // oldDateFormat
};

const NgzDetailedRevenueTab = ({
  entityId,
  entityRegistrationDate,
}: NgzDetailedRevenueTabProps) => {
  return (
    <DetailedRevenue
      entityId={entityId}
      entityRegistrationDate={entityRegistrationDate}
    />
  );
};

angularizeWithProviders(NgzDetailedRevenueTab, 'ngzDetailedRevenueTab', {
  entityId: '<',
  entityRegistrationDate: '<',
});

export { NgzDetailedRevenueTab };
